export default {
  fileuploader: {
    url: "/api/v1/content/upload",
    method: "post",
  },
  filedeleter: {
    url: "/api/v1/content/upload/{attachmentId}",
    method: "delete",
  },
  fileDownloader: {
    url: "/api/v1/content/upload/{attachmentId}",
    method: "get",
  },
  getFileMetaData: {
    url: "/api/v1/content/upload/metadata/{attachment_id}",
    method: "get",
  },
  fileuploaderpublic: {
    url: "/api/v1/content/upload/public",
    method: "post",
  },
  getAllPackages: {
    url: "/api/v2/package/open",
    method: "get",
  },
  getAllAccessiblePackages: {
    url: "/api/v2/package/accessible_packages",
    method: "get",
  },
  getPackageById: {
    url: "/api/v2/package/open/{package_id}",
    method: "get",
  },
  getSubModules: {
    url: "/api/v2/module/sub",
    method: "get",
  },
  getCurriculumGrades: {
    url: "/api/v1/content/curriculum/open",
    method: "get",
  },
  getContentBySession: {
    url: "/api/v2/content/customer/{session_id}/{content_type}",
    method: "get",
  },
  getcontentSessionById: {
    url: "/api/v2/session/{session_id}",
    method: "get",
  },
  getAssessments: {
    url: "/api/v1/content/assessment/{session_id}",
    method: "get",
  },
  getAssessmentById: {
    url: "/api/v1/content/assessment/id/{assessment_id}",
    method: "get",
  },
  addCustomerAssessment: {
    url: "/api/v2/customer/assessment/submit",
    method: "post",
  },
  getAssessmentHistory: {
    url: "/api/v1/customer/assessment/history/{session_id}",
    method: "get",
  },
  getCustomerAssessmentDetails: {
    url: "/api/v1/customer/assessment/{assessment_id}",
    method: "get",
  },
  scanQRcode: {
    url: "/api/v2/qrcode/scan",
    method: "post",
  },
};